import React, { useEffect, useState } from "react";
import { Card, Table, TableHead, TableRow, TableCell, TableBody, TableFooter, Typography, TableContainer, CircularProgress, Grid } from "@mui/material";
import axios from "axios";
import Chart, {
    ArgumentAxis,
    CommonSeriesSettings,
    Legend,
    Series,
    Tooltip,
    ValueAxis,
} from 'devextreme-react/chart';

// ** Utils Import

interface OrderStatus {
    printing: number;
    dyeing: number;
    digital: number;
}


// Data dummy chart
const datas = [
    { month: 'Jan', value: 20 },
    { month: 'Feb', value: 35 },
    { month: 'Mar', value: 40 },
    { month: 'Apr', value: 55 },
    { month: 'May', value: 30 },
];

export default function DashboardCardChart2() {
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState<any>([]);

    useEffect(() => {
        const fetchData = () => {
            setLoading(true)
            setData(datas)
            // axios.get(apiUrl.apiUrl + "/api/produksi/dashboard-produksi/tabel-onhand").then((res) => {
            //     const datas = res.data.data
            //     setData(datas);
            //     setLoading(false)
            // });
            setLoading(false)
        };


        fetchData();
        const interval = setInterval(fetchData, 600000);

        return () => clearInterval(interval);
    }, []);

    return (
        <Card sx={{ height: 250, overflow: "hidden" }}>
            {loading ? (
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', margin: 10 }}>
                    <CircularProgress disableShrink sx={{ mt: 6, height: '100%' }} />
                </Grid>
            ) : (

                <Chart
                    dataSource={data}
                    id="chart"
                    style={{ width: "100%", height: "100%" }}
                >
                    <CommonSeriesSettings argumentField="month" />
                    <Series
                        valueField="value"
                        name="Output"
                        type="bar"
                        color="#42a5f5"
                    />
                    <ArgumentAxis />
                    <ValueAxis>
                        <Legend visible={false} />
                    </ValueAxis>
                    <Tooltip enabled={true} />
                </Chart>
            )}
        </Card>
    );
}
